import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { ILocationState }          from 'Redux/Slices/Location/LocationSlice';
import { removeActionTypes } from 'Utils/ReducerUtility';

export const deleteLocationRequest = (state: Draft<ILocationState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const deleteLocationSuccess = (state: Draft<ILocationState>, { type, payload }: PayloadAction<{
  id: string
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  const newEntries = { ...state.entries };
  if (payload.id in newEntries) {
    delete newEntries[payload.id];
  }
  state.entries = newEntries;
};

export const deleteLocationFailure = (state: Draft<ILocationState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
